export const MATERIAL_WATCHLIST_KEYWORDS = [
  'acrylic',
  'acutely toxic',
  'aluminium composite panel, ACP',
  'alkylphenol ethoxylates, APEs',
  'alkylphenols',
  'animal hides',
  'antimony',
  'asbestos',
  'bisphenol A, BPA',
  'cadmium',
  'chlorinated polyethylene, CPE',
  'chlorinated polyvinylchloride, CPVC',
  'chlorobenzene',
  'chlorofluorocarbons, CFC',
  'chloroprene',
  'chlorosulfonated polyethylene, CSPE',
  'chromium',
  'di-2-ethylhexyl phthalate, DEHP',
  'engineered nanomaterials, ENMs',
  'fibreglass',
  'fly ash',
  'formaldehyde',
  'fossil',
  'halogenated',
  'halogenated flame retardants, HFR',
  'hexavalent chromium',
  'hydrochlorofluorocarbons, HCFC',
  'lead',
  'man made mineral fibre, MMF',
  'mercury',
  'neoprene',
  'perfluorinated compounds, PFC',
  'perfluoroalkyl, PFAS',
  'persistent bio-accumulative toxic, PBT',
  'phthalates',
  'phthalates, di-2-ethylhexyl phthalate, DEHP',
  'polychlorinated biphenyls, PCB',
  'polychloroprene rubber, CR',
  'polyfluoroalkyl, PFAS',
  'polyisocyanate',
  'polystyrene',
  'polyurethane',
  'polyvinylchloride, PVC',
  'polyvinylidene chloride, PVDC',
  'rayon',
  'serious health hazard',
  'wood wool',
  'viscose'
]
